import { isPending } from "App/apiMiddleware";
import { ACTION_LOG_TYPE } from "Common/dictionaries/actionLogType";
import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE as PAGE_NAMESPACE } from "../../constants";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getActionLogEventTypeDictionary = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].actionLogEventTypeDictionary`), (actionLogEventTypeDictionary) => actionLogEventTypeDictionary);
export const getActionLogUsers = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].actionLogUsers`), (actionLogUsers) => actionLogUsers);
export const getActionLogProjects = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].actionLogProjects`), (actionLogProjects) => actionLogProjects);
export const getActionLogType = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].actionLogType`), (type) => type || ACTION_LOG_TYPE.SYSTEM_ACCESS);
export const getInProgress = (state) => isPending(state, actionTypes.EXPORT) ||
    isPending(state, actionTypes.GET_ACTION_LOG_EVENT_TYPE_DICTIONARY) ||
    isPending(state, actionTypes.GET_ACTION_LOG_USERS) ||
    isPending(state, actionTypes.GET_ACTION_LOG_PROJECTS);
